
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import ControlClose from './control-close'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "controlclose"
    }}>{`ControlClose`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Controls`}</p>
    <hr />
    <h2 {...{
      "id": "close"
    }}>{`Close`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For dismissing a persistent element, such as an alert, or reverting a temporary change in the state of the interface.`}</p>
    <Playground __position={1} __code={'<ControlClose />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlClose
    }} mdxType="Playground">
  <ControlClose mdxType="ControlClose" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={2} __code={'<ControlClose disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlClose
    }} mdxType="Playground">
  <ControlClose disabled mdxType="ControlClose" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "close-full-screen"
    }}>{`Close (full screen)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For dismissing a persistent element, such as an alert, or reverting a temporary change in the state of the interface.`}</p>
    <Playground __position={4} __code={'<ControlClose fullScreen />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlClose
    }} mdxType="Playground">
  <ControlClose fullScreen mdxType="ControlClose" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={5} __code={'<ControlClose fullScreen disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlClose
    }} mdxType="Playground">
  <ControlClose fullScreen disabled mdxType="ControlClose" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "close-inverse"
    }}>{`Close (inverse)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For dismissing a persistent element, such as an alert, or reverting a temporary change in the state of the interface.`}</p>
    <Playground __position={7} __code={'<ControlClose inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlClose
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlClose inverse mdxType="ControlClose" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={8} __code={'<ControlClose inverse disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlClose
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlClose inverse disabled mdxType="ControlClose" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "close-inverse-full-screen"
    }}>{`Close (inverse, full screen)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For dismissing a persistent element, such as an alert, or reverting a temporary change in the state of the interface.`}</p>
    <Playground __position={10} __code={'<ControlClose fullScreen inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlClose
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlClose fullScreen inverse mdxType="ControlClose" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={11} __code={'<ControlClose fullScreen inverse disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlClose
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlClose fullScreen inverse disabled mdxType="ControlClose" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={ControlClose} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;